import React from "react";
import Style from "../Style/AdminHeader.module.scss";
import { FaBars } from "react-icons/fa";
import logo from "../Img/optimyz logo desig.png";

const AdminHeader = ({ toggleSidebar }) => {
  return (
    <div className={Style.Adminheader}>
      <div className={Style.AdminHeaderLeft}>
        <img src={logo} alt="Logo" />
      </div>
      <div className={Style.AdminHeaderRight}>
        <FaBars className={Style.menuIcon} onClick={toggleSidebar} />
      </div>
    </div>
  );
};

export default AdminHeader;
